import { Component, inject, OnInit, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MsalService } from '@azure/msal-angular';
import { TranslatePipe } from '@ngx-translate/core';
import { routingConstants } from '../../_constants/routing-constants.const';
import { AccessMe, AccessService } from '../../_services/access.service';

// Shown instead of the application when the logged-in user has no access to this tenant.
@Component({
  selector: 'app-no-access',
  imports: [TranslatePipe, MatButtonModule],
  templateUrl: './no-access.html',
  styleUrl: './no-access.scss',
})
export class NoAccess implements OnInit {
  private readonly accessService = inject(AccessService);
  private readonly authService = inject(MsalService);

  public readonly me = signal<AccessMe | null>(null);

  public ngOnInit(): void {
    this.accessService.getMe().subscribe((me) => this.me.set(me));
  }

  // A full reload: /access/me is cached for the session.
  public retry(): void {
    window.location.href = '/';
  }

  public logout(): void {
    this.authService.logoutRedirect({
      postLogoutRedirectUri: location.origin + '/' + routingConstants.login,
    });
  }
}
